var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-progress-container"},[_c('ul',{staticClass:"step-progress-bar"},_vm._l((_vm.stepSize),function(step){return _c('li',{key:step,class:{
        active: _vm.stepNumber === step,
        finish: _vm.stepNumber > step
      },style:(_vm.stepWidth)})}),0),_c('p',{staticClass:"step-title"},[_vm._v(_vm._s(_vm.stepTitle))]),_c('hr',{staticClass:"step-row hide-on-large"})])
}
var staticRenderFns = []

export { render, staticRenderFns }